export default __webpack_public_path__ + "static/media/glrc-course.plant-based-garde-manger.f14d36f4.png";